export const BINARY_OPTIONS_ERROR = {
  required: {
    path: 'selection-required',
    message: 'Select an option to continue',
  },
};

export const DEFECT_OPTIONS_ERROR = {
  required: {
    path: 'defect-option-required',
    message: 'Select an option',
  },
};

export const UPLOAD_PHOTO_ERROR = {
  wrong_type: {
    path: 'file-wrong-type',
    message: 'The file must be a JPEG, PNG, GIF or WebP',
  },
  too_large: {
    path: 'file-too-large',
    message: 'The file must be smaller than 30mb',
  },
};

export const ANYTHING_ELSE_ERROR = {
  required: {
    path: 'anythingElseText',
    message: 'Enter location information such as landmarks or buildings',
  },
  maxLength: {
    path: 'anythingElseText',
    message: `Details on the location must be 500 characters or less.`,
  },
};

export const RECEIVE_EMAIL_ERROR = {
  required: {
    path: 'wantConfirmationEmail',
    message: 'Select if you want to receive a confirmation email.',
  },
};

export const VALID_ID_ERROR = {
  required: {
    path: 'valid-id',
    message: `Enter a valid cycle hangar ID.`,
  },
};

export const VALID_LOCK_CODE_ERROR = {
  required: {
    path: 'valid-id',
    message: `Please enter a valid lock code.`,
  },
};

export const TYPE_OF_ISSUE_ERROR = {
  required: {
    path: 'valid-id',
    message: `You must select the type of issue you are reporting.`,
  },
};

export const SELECT_OPTIONS_ERROR = {
  required: {
    path: 'selection-required',
    message: 'Select an answer to continue.',
  },
};
